import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "32",
  height: "32",
  fill: "currentColor",
  rx: "4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M15.143 7.824a1 1 0 0 1 1.714 0l2.084 3.464a1 1 0 0 0 .632.458l3.938.912a1 1 0 0 1 .53 1.63l-2.65 3.053a1 1 0 0 0-.242.742l.35 4.028a1 1 0 0 1-1.386 1.007l-3.723-1.577a1 1 0 0 0-.78 0l-3.723 1.577a1 1 0 0 1-1.386-1.007l.35-4.028a1 1 0 0 0-.242-.742l-2.65-3.053a1 1 0 0 1 .53-1.63l3.938-.912a1 1 0 0 0 .631-.458z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }